var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.91 0.648438L0 1.62344L4.81 6.49844L0 11.3734L0.91 12.3484L6.76 6.49844L0.91 0.648438Z",
    fill: "#20639B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMoreIcon);
export default __webpack_public_path__ + "static/media/seeMoreIcon.6a2c48110a7172b638e0b38a728bf74e.svg";
export { ForwardRef as ReactComponent };